export const questionLabels = {
  birthRegister: 'Possui registro de nascimento',
  summationLastMonthIncomePerMember: 'Renda do último mês',
  hasChildLabor: 'Há trabalho infantil na família?',
  pregnantInHome: 'Há gestante no domicílio?',
  someoneWorks: 'Alguém trabalha?',
  numberOfWorkers: 'Número de trabalhadores',
  sourceOfIncome: 'Fonte de renda',
  lastMonthIncome: 'Renda do último mês',
  madeQualificationCourse: 'Curso de qualificação feito?',
  wantToMakeQualificationCourse: 'Quer fazer um curso de qualificação?',
  familyMeanCapital: 'Média de capital familiar',
  waterExpense: 'Despesas com água',
  foodExpense: 'Despesas com comida',
  rentExpense: 'Despesas com aluguel',
  lightingExpense: 'Despesas com energia',
  remedyExpense: 'Despesas com remédios',
  transportExpense: 'Despesas com transporte',
  gasExpense: 'Despesas com gás',
  totalExpense: 'Despesa total da família',
  address: 'Endereço',
  cep: 'CEP',
  zone: 'Zona',
  city: 'Cidade',
  waterSuply: 'Forma de abastecimento de água',
  pipedWater: 'Possui água canalizada em pelo menos um cômodo?',
  drinkableWater: 'Água utilizada para beber',
  hasBathroom: 'Existe banheiro ou sanitário',
  paving: 'Existe calçamento/pavimentação no trecho do logradouro',
  garbageDisposal: 'Forma de coleta/destino do lixo',
  garbageCollectionFrequency: 'Coleta de lixo ocorre quantas vezes na semana',
  sanitaryDrainage: 'Forma de escoamento do banheiro ou sanitário',
  houseType: 'Espécie do domicílio?',
  formOfLighting: 'Iluminação utilizada no domicílio?',
  houseZone: 'O local do domicílio tem, na maioria, características',
  wallsMaterial: 'Material predominante das paredes externas',
  floorMaterial: 'Material predominante no piso',
  numberOfRooms: 'Total de cômodos do domicílio',
  numberOfBedrooms:
    'Cômodos usados, permanentemente, de dormitório para os moradores do domicílio',
  placesToPlayNearby:
    'Existem lugares públicos para as crianças brincarem próximo a casa',
  culturalActivitiesNearby: 'Existem atividades culturais próximo a casa',
  sportsActivitiesPlaceNearby:
    'Existem locais para atividades esportivas próximo a casa',
  dangerZone: 'Localizado em área de conflito/violência?',
  numberOfResidents: 'Número de residentes na casa',
  numberOfFamilies: 'Número de famílias na casa',
  indigenousFamily: 'Família indígena?',
  indigenousLand: 'Território indígena',
  indigenousCommunity: 'Comunidade indígena',
  indigenousReserve: 'Reserva indígena',
  kilombolaFamily: 'Família quilombola?',
  kilombolaCommunity: 'Comunidade quilombola?',
  animalsForConsumption: 'Criação de animais para consumo',
  foodAvailabilityAfterCovid: 'Menos alimento após pandemia de COVID-19',
  foodConcern: 'Comer menos por falta de dinheiro',
  foodDeficiency: 'Preocupação relacionada a falta de alimento',
  foodEndedEarly: 'Alimentação acabou antes de haver dinheiro',
  healthyFoodDeficiency: 'Falta de dinheiro para ter alimentação saudável',
  plantsForConsumption: 'Plantação de alimentos para consumo',
  skipedMeal: 'Falta de refeição',
  familyAssistenceEstablishment: 'Estabelecimento de assistência familiar',
  healthAssistenceEstablishment: 'Estabelecimento de assistência à saúde',
  crasActivity: 'CRAS',
  creasActivity: 'CREAS',
  govenmentAid: 'Governo do Estado do Ceará',
  childLabor: 'Realiza trabalho infantil?',
  vaccinesCard: 'Possui caderneta de vacina da criança',
  vaccinesUpToDate: 'A criança está com as vacinas em dia',
  familyVisitingProgram:
    'A criança participa de algum programa de visitação domiciliar?',
  disability: 'A criança possui alguma deficiência congênita?',
  familyHealthTeam: 'A criança é acompanhada pela equipe da saúde da família?',
  breastfedFirstHour: 'A criança mamou na primeira hora após nascer?',
  breastfedUntilAge: 'Até que idade a criança mamou no peito?',
  thirdPartyAssistance: 'Criança possui assistência de terceiros?',
  attendsSchool: 'Está matriculada em uma escola?',
  currentSchoolGrade: 'Qual a série e o grau de ensino?',
  currentSchoolName: 'Qual o nome da escola atual?',
  currentCourse: 'Qual o curso atual?',
  highestEducationLevel: 'Frequentou escola até qual série?',
  canReadWrite: 'Sabe ler e escrever?',
  awayFromWork: 'Está afastado do trabalho?',
  workedLastWeek: 'Trabalhou na última semana?',
  lastMonthWorkIncome: 'Renda do trabalho no último mês',
  agricultureWork: 'Trabalha em zona rural?',
  jobType: 'Tipo de trabalho',
  workedLastYear: 'Trabalhou no último ano?',
  lastYearWorkedMonths: 'Trabalhou quantos meses no último ano?',
  lastYearWorkIncome: 'Renda do trabalho no último ano',
  otherIncomesPerMonth: 'Outras rendas mensais',
  retirementIncomesPerMonth: 'Renda da aposentadoria mensal',
  donationIncomesPerMonth: 'Rendas de doações mensais',
  alimonyIncomesPerMonth: 'Pensão alimentícia mensal',
  unemploymentInsuranceIncomesPerMonth: 'Renda do seguro desemprego mensal',
}
